import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  title: string
  text?: string
  children?: React.ReactNode
  className?: string
  id?: string
}

/** Heading on the left, content on the right. Stacks on mobile. */
export const InfoPageSection = ({
  title,
  text,
  children,
  className,
  id,
}: Props) => (
  <section id={id} className={className}>
    <div className='max-w-6xl px-4 mx-auto py-14 sm:px-6 md:py-20 lg:grid lg:grid-cols-12 lg:gap-12'>
      <h2 className='h2 lg:col-span-5'>{title}</h2>

      <div className='mt-8 lg:mt-0 lg:col-span-7'>
        {text && <p className='pb-8 body'>{text}</p>}
        {children}
      </div>
    </div>
  </section>
)

type LineItemProps = {
  title: string
  description: string
  /** Internal route */
  to?: string
  /** External link */
  href?: string
  linkText?: string
}

export const InfoLineItem = ({
  title,
  description,
  to,
  href,
  linkText = 'Learn more',
}: LineItemProps) => (
  <div className='py-6 border-t border-rule'>
    <h3 className='h3'>{title}</h3>
    <p className='mt-2 body'>{description}</p>
    {to && (
      <Link to={to} className='inline-block mt-3 link'>
        {linkText}
      </Link>
    )}
    {href && (
      <a
        href={href}
        target='_blank'
        rel='noreferrer'
        className='inline-block mt-3 link'>
        {linkText}
      </a>
    )}
  </div>
)
